// menuTree.js
// Normaliza y arma el árbol del menú para el sidebar con persistencia de IDs.

function normalizeNodes(flatItems = []) {
  return flatItems.map(x => ({
    id: x.idMenu,
    idModulo: x.idModulo,
    parentId: x.idPadre ?? null,
    level: Number(x.nivel) || 0,
    clave: (x.clave ?? "").toString().trim(),
    title: (x.nombre ?? "").trim(), // Limpieza de espacios
    route: (x.ruta || "").toString().trim(),
    order: x.orden ?? 0,
    icono: (x.icono ?? "").toString().trim(),
    esRaizModulo: !!x.esRaizModulo,
    children: [],
  }));
}

function sortRec(arr) {
  arr.sort((a, b) => {
    const ao = a?.order ?? 0;
    const bo = b?.order ?? 0;
    if (ao !== bo) return ao - bo;
    return String(a?.title ?? "").localeCompare(String(b?.title ?? ""), "es");
  });
  for (const n of arr) {
    if (n?.children?.length) sortRec(n.children);
  }
}

function adaptForSidebar(n) {
  return {
    id: n.id, // 🔹 Importante: Mantenemos el ID
    parentId: n.parentId, // 🔹 Importante: Mantenemos el ParentID
    clave: n.clave,
    title: n.title,
    route: n.route,
    icono: n.icono,
    children: (n.children || []).map(adaptForSidebar),
  };
}

export function buildSidebarTree(flatItems) {
  const nodes = normalizeNodes(flatItems);
  const byId = new Map(nodes.map(n => [n.id, n]));

  const roots = [];
  for (const n of nodes) {
    const pid = n.parentId;
    if (pid && pid !== n.id && byId.has(pid))
      byId.get(pid).children.push(n);
    else
      roots.push(n);
  }

  sortRec(roots);
  return roots.map(adaptForSidebar);
}

export function buildSidebarTreeForModule(flatItems, activeTop) {
  const top = String(activeTop);
  const filtered = (flatItems || []).filter(x => String(x.idModulo) === top);
  return buildSidebarTree(filtered);
}
